module.exports = __webpack_public_path__ + "img/ancient.6211215e.jpg";